import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 17v-10l7 10v-10","key":"svg-0"}],["path",{"d":"M15 17h5","key":"svg-1"}],["path",{"d":"M15 10a2.5 3 0 1 0 5 0a2.5 3 0 1 0 -5 0","key":"svg-2"}]]

const IconNumber = createReactComponent('outline', 'number', 'Number', __iconNode);

export default IconNumber;